import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";
import type { ReplacementCharacterItem } from "../types/api-types";
import { getCharFromCode } from "./utils";

interface ReplacementCharacterDeleteDialogProps {
  open: boolean;
  character: ReplacementCharacterItem | null;
  isDeleting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const ReplacementCharacterDeleteDialog = ({
  open,
  character,
  isDeleting,
  onConfirm,
  onCancel,
}: ReplacementCharacterDeleteDialogProps) => {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>Confirm Delete</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete this replacement character?
        </DialogContentText>
        {character && (
          <Box
            sx={{
              display: "flex",
              gap: 2,
              mt: 2,
              p: 1.5,
              bgcolor: "grey.100",
              borderRadius: 1,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography
              component="span"
              sx={{ fontWeight: 600, fontSize: "1.2rem" }}
            >
              {getCharFromCode(character.asciiValue)}
            </Typography>
            <Typography component="span" color="text.secondary">
              →
            </Typography>
            <Typography
              component="span"
              sx={{ fontWeight: 600, fontSize: "1.2rem" }}
            >
              {getCharFromCode(character.replacementValue)}
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onCancel} variant="outlined" disabled={isDeleting}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          disabled={isDeleting}
          startIcon={isDeleting ? <CircularProgress size={16} /> : null}
        >
          {isDeleting ? "Deleting..." : "Delete"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReplacementCharacterDeleteDialog;
